import React from "react"
import {Button} from "@uprise/button"
import {SocialButton} from "components/shared/Button"
import {BASE_URL} from "helpers/api"
import {useAuth0} from "@auth0/auth0-react"

const styles = {
	card: {
		maxWidth: "350px",
		margin: "0 auto"
	},
	logo: {
		width: "150px",
		margin: "0 auto"
	}
}

const Login = () => {
	const {user, isAuthenticated, loginWithRedirect, logout} = useAuth0()
	return (
		<div style={{minHeight: "100vh", marginBottom: "0"}} className='jumbotron'>
			<div className='container'>
				<div className='text-center' style={styles.card}>
					<img src='/logo.png' className='img-responsive' style={styles.logo} />
					<br />
					<br />
					<SocialButton
						variant='primary'
						className='m-b-4'
						data-testid='sign-in-button'
						title='Login'
						size='large'
						fullWidth={true}
						isLoading={false}
						disabled={false}
						onClick={() => loginWithRedirect()}
					/>
				</div>
			</div>
		</div>
	)
}

export default Login
